import ValidationRule from '../validation.rule.js';
import PasswordItemRule from './password-item.rule';

export default class AtLeastNCharsRule extends PasswordItemRule {
    isValid() {
        return this.password.element.value.length >= this.length;
    }

    getRuleName() {
        return 'at-least-n-chars';
    }
}
